module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cUAQd"))).then(() => parcelRequire('hEqeo'));